'use client';


import { theme } from "../../theme/index.js";
import { ColorThemeProvider, useColorTheme } from "../ColorThemeProvider.js";
import { useColors } from "../../hooks/useColors.js";
import { ThemeColorModeSync } from "../ThemeColorModeSync.js";
import { ChakraProvider } from "@chakra-ui/react";
import { c } from "react-compiler-runtime";
import { jsx } from "react/jsx-runtime";

//#region src/providers/Root/Root.tsx
const ChakraProviderImpl = (t0) => {
	const $ = c(15);
	const { children, isRTL, primaryColor, secondaryColor, locale: t1 } = t0;
	const locale = t1 === void 0 ? "en" : t1;
	let t2;
	if ($[0] !== primaryColor || $[1] !== secondaryColor) {
		t2 = {
			primaryColor,
			secondaryColor
		};
		$[0] = primaryColor;
		$[1] = secondaryColor;
		$[2] = t2;
	} else t2 = $[2];
	const colors = useColors(t2);
	const { colorMode } = useColorTheme();
	let t3;
	let t4;
	if ($[3] !== colorMode) {
		t4 = { initialColorMode: colorMode };
		$[3] = colorMode;
		$[4] = t4;
	} else t4 = $[4];
	const t5 = isRTL ? "rtl" : "ltr";
	let t6;
	if ($[5] !== colors || $[6] !== locale || $[7] !== t4 || $[8] !== t5) {
		t6 = {
			config: t4,
			...theme,
			colors,
			direction: t5,
			locale
		};
		$[5] = colors;
		$[6] = locale;
		$[7] = t4;
		$[8] = t5;
		$[9] = t6;
	} else t6 = $[9];
	t3 = t6;
	const themeObj = t3;
	let t7;
	if ($[10] !== children) {
		t7 = /* @__PURE__ */ jsx(ThemeColorModeSync, { children });
		$[10] = children;
		$[11] = t7;
	} else t7 = $[11];
	let t8;
	if ($[12] !== t7 || $[13] !== themeObj) {
		t8 = /* @__PURE__ */ jsx(ChakraProvider, {
			theme: themeObj,
			resetCSS: false,
			disableEnvironment: true,
			children: t7
		});
		$[12] = t7;
		$[13] = themeObj;
		$[14] = t8;
	} else t8 = $[14];
	return t8;
};
const Root = (props) => {
	const $ = c(2);
	let t0;
	if ($[0] !== props) {
		t0 = /* @__PURE__ */ jsx(ColorThemeProvider, { children: /* @__PURE__ */ jsx(ChakraProviderImpl, { ...props }) });
		$[0] = props;
		$[1] = t0;
	} else t0 = $[1];
	return t0;
};
var Root_default = Root;

//#endregion
export { Root_default as default };
//# sourceMappingURL=Root.js.map